export type User = {
  id?: string;
  first_name: string;
  last_name: string;
  email?: string;
  password?: string;
  delete_scheduled?: boolean;
  delete_on?: string;
  avatar?: string;
  has_avatar: boolean;
  avatarKey?: string;
  key_id?: string;
  has_password?: boolean;
  private_key_armored?: string;
  public_key_armored?: string;
}

export enum PermissionLevels {
  OWNER = 'owner',
  ADMIN = 'admin',
  MEMBER = 'member',
  OPEN = 'open',
  GUEST = 'guest',
}